import React from "react";
import { Avatar } from "@/components/community/ChatList";
import { ImageOff } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const money = (n, currency = "MXN") =>
  `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2 })} ${currency}`;

const TONES = {
  disponible: { label: "Disponible", color: "#17C964" },
  reservado: { label: "Reservado", color: "#F5A524" },
  vendido: { label: "Vendido", color: "#FF8A2B" },
};

export const StatusChip = ({ status }) => {
  const tone = TONES[status] || TONES.disponible;
  return (
    <span className="text-[10px] uppercase tracking-[0.14em] px-2 py-1 rounded-full border"
      style={{ color: tone.color, borderColor: `${tone.color}55`, background: `${tone.color}1A` }}
      data-testid={`chip-${status}`}>
      {tone.label}
    </span>
  );
};

/** Tarjeta de producto del mercado. */
export const ProductCard = ({ product, onOpen }) => {
  const cover = product.media?.[0];
  return (
    <button data-testid={`product-card-${product.product_id}`} onClick={() => onOpen(product)}
      className="glass-card overflow-hidden text-left transition-transform duration-300 hover:-translate-y-1 hover:border-red-500/40">
      <div className="relative aspect-[4/3] bg-black/40 overflow-hidden">
        {cover ? (
          <img src={`${BACKEND}${cover.url}`} alt={product.title}
            className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-white/25">
            <ImageOff className="w-7 h-7" />
          </div>
        )}
        <div className="absolute top-2 left-2"><StatusChip status={product.status} /></div>
        {product.media?.length > 1 && (
          <div className="absolute bottom-2 right-2 text-[10px] text-white/80 px-2 py-0.5 rounded-full"
            style={{ background: "rgba(0,0,0,0.55)" }}>
            {product.media.length} fotos
          </div>
        )}
      </div>
      <div className="p-3.5">
        <div className="text-white text-sm font-semibold truncate">{product.title}</div>
        <div className="text-red-300 font-bold mt-1">{money(product.price, product.currency)}</div>
        <div className="flex items-center gap-2 mt-3">
          <Avatar person={product.seller} size={24} />
          <span className="text-[11px] text-white/50 truncate">
            {product.mine ? "Tu producto" : product.seller?.name || "Miembro"}
          </span>
        </div>
      </div>
    </button>
  );
};

export default ProductCard;
